<div *ngIf="roles$ | async as roles">
  <div class="bg-secondary-subtle shadow-sm sidebar" *ngIf="home && visibleMenu && visibleMenu.length && widgetsLoaded">
    <div class="wrapper">
      <ul>
        <li>
          <a class="trans-ease cursor-pointer" (click)="clickMenuItem()" [ngbTooltip]="home.label" placement="end" container="body" [ngClass]="{ active: homeActive }">
            <i class="fas fa-home"></i>
          </a>
        </li>
        <li *ngIf="visibleMenu && visibleMenu.length"></li>
        <li *ngFor="let menuItem of visibleMenu">
          <ng-container *ngIf="menuItem && menuItem.menu">
            <a class="trans-ease cursor-pointer" [ngClass]="{ active: menuItem.active }" (click)="clickMenuItem(menuItem)" [ngbTooltip]="menuItem.menu?.label" placement="end" container="body">
              <!-- <i [ngClass]="[menuItem.icon || 'fas fa-file']"></i> -->
              <div *ngIf="menuItem.customIcon; else checkCustomIcon" [innerHTML]="menuItem.customIcon | safeHTML" class=""></div>

              <ng-template #checkCustomIcon>
                <img *ngIf="menuItem.customCssIcon" [src]="menuItem.customCssIcon" class="custom-img" />
                <i *ngIf="!menuItem.customCssIcon" [ngClass]="[menuItem.icon]" class=""></i>
              </ng-template>
            </a>
          </ng-container>
        </li>
      </ul>
    </div>
  </div>
</div>

<ng-template #modalcontent let-modal>
  <div>
    <div class="modal-header">
      <h5 class="modal-title">
        {{ 'choose-company' | label : 'company-selection' | async }}
      </h5>
      <button type="button" class="btn-close" aria-label="close" (click)="modal.dismiss()"></button>
    </div>
    <div class="modal-body" style="overflow: initial; max-height: initial">
      <ul>
        <li *ngFor="let company of companies" (click)="modal.close(company.id)">
          <a>{{ company.name }}</a>
        </li>
      </ul>
    </div>
  </div>
</ng-template>
